module.exports = __webpack_public_path__ + "img/login-v3.c2f71ea1.png";